// DS9.5
import React from 'react';
import c from 'classnames';
import { sanitizeHref } from '@wix/da-url';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import Button, { GhostButtonProps } from '../Buttons/GhostButton';
import SolidButton from '../Buttons/SolidButton';

import s from './InfoBlock.scss';

export interface Props {
  className?: string;
  /** @deprecated only for backwards compatibility with old UP empty states */
  titleClassName?: string;
  /** @deprecated only for backwards compatibility with old UP empty states */
  subtitleClassName?: string;
  illustration?: React.ReactNode;
  illustrationClassName?: string;
  withIllustrationBelow?: boolean;
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  withButton?: boolean;
  buttonLabel?: string;
  buttonHref?: string;
  buttonVariant?: GhostButtonProps['variant'];
  buttonAlignment?: 'horizontal' | 'vertical';
  backgroundType?: 'solid' | 'overlay' | 'none';
  customButton?: React.ReactNode;
  customSecondaryButton?: React.ReactNode;
  height?: number;
  onButtonClick?: () => void;
  biData?: BiEvent;
}

const InfoBlock: React.FC<Props> = ({
  className,
  titleClassName,
  subtitleClassName,
  withIllustrationBelow,
  title,
  subtitle,
  illustration,
  illustrationClassName,
  withButton,
  buttonLabel,
  buttonHref,
  buttonAlignment = 'horizontal',
  buttonVariant,
  backgroundType = 'solid',
  customButton,
  customSecondaryButton,
  height,
  onButtonClick,
  biData,
}) => {
  return (
    <div
      className={c(
        s['root'],
        s[`background-${backgroundType}`],
        height && s['with-fixed-height'],
        className
      )}
      style={{ height }}
    >
      {illustration && (
        <div
          className={c(
            s['illustration'],
            withIllustrationBelow && s['illustration-below'],
            illustrationClassName
          )}
        >
          {illustration}
        </div>
      )}
      <div className={c(s['title'], titleClassName)}>{title}</div>
      <div className={c(s['subtitle'], subtitleClassName)}>{subtitle}</div>
      <div
        className={c(
          s['buttons'],

          buttonAlignment == 'vertical' && s['buttons-vertical']
        )}
      >
        {customSecondaryButton}
        {customButton ||
          (withButton &&
            (buttonVariant ? (
              <SolidButton
                variant={buttonVariant}
                size="medium"
                onClick={onButtonClick}
                biData={biData}
                href={sanitizeHref(buttonHref)}
              >
                {buttonLabel}
              </SolidButton>
            ) : (
              <Button
                variant="main"
                size="medium"
                onClick={onButtonClick}
                biData={biData}
                href={sanitizeHref(buttonHref)}
              >
                {buttonLabel}
              </Button>
            )))}
      </div>
    </div>
  );
};
InfoBlock.displayName = 'InfoBlock';

export default InfoBlock;
